import React, { useEffect, useRef, useState } from 'react';
import HeaderContext from './components/HeaderContext';
import Explore from './Explore/index';
import '@/pages/home/assets/scss/page/home/index.scss';
import headerGoTop from '@/pages/home/assets/img/header-go-top.png';
import { useDispatch } from 'umi';
import { useMount } from 'ahooks';
import { CRON_EXPRESSIONS_MODEL_NAMESPACE } from '@home/models/cronExpressions';
import useYearlyPoster from './_hooks/useYearlyPoster';

export default () => {
  const dispatch = useDispatch();

  const { loading: showYearlyPosterLoading, show: showYearlyPoster } = useYearlyPoster();
  const [holidayExpanded, setHolidayExpanded] = useState<boolean>(false);
  const [isDocked, setIsDocked] = useState<boolean>(false);

  const ScollRef: any = useRef(null);
  const pageScrollRef = useRef<HTMLDivElement>(null);

  // 监听 Copilot docked 状态
  useEffect(() => {
    const checkDocked = () => {
      const docked = document.querySelector('.dbh-agent-copilot--docked') !== null;
      setIsDocked(docked);
    };
    checkDocked();
    const observer = new MutationObserver(checkDocked);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true });
    return () => observer.disconnect();
  }, []);

  // Copilot 嵌入时主内容区变窄，复用现有图表的 window.resize 监听
  useEffect(() => {
    const el = pageScrollRef.current;
    if (!el) {
      return;
    }
    const ro = new ResizeObserver(() => {
      window.dispatchEvent(new Event('resize'));
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const goTop = () => {
    const target = isDocked ? pageScrollRef.current : ScollRef.current;
    if (target) {
      target.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };
  useMount(() => {
    dispatch({ type: `${CRON_EXPRESSIONS_MODEL_NAMESPACE}/getCRONExpressions` });
  });
  return (
    <>
      <div className="hame-page">
        <HeaderContext
          ScollRef={ScollRef}
          showYearlyPosterLoading={showYearlyPosterLoading}
          showYearlyPoster={showYearlyPoster}
          holidayExpanded={holidayExpanded}
          onToggleHoliday={() => setHolidayExpanded(prev => !prev)}
        />
        <div className="hame-page-board" ref={ScollRef}>
          <div className="hame-page-scroll" ref={pageScrollRef}>
            <div className="hame-page-scroll-content">
              <Explore showYearlyPoster={showYearlyPoster} holidayExpanded={holidayExpanded} />
            <div className='dbh-footer-truste'>
              <a href="//privacy.trustarc.com/privacy-seal/validation?rid=f097bd06-13da-4fd2-aacb-b78867633cfd" target="blank">
                <img style={{ border: 'none' }} src="//hostedseal.trustarc.com/privacy-seal/seal?rid=f097bd06-13da-4fd2-aacb-b78867633cfd" alt="TRUSTe" />
              </a>
            </div>
            <div className="hame-page-scroll-top" onClick={goTop}>
              <img src={headerGoTop} alt="" srcSet="" width={14} />
            </div>
            </div>
          </div>
          {/* Copilot 固定停靠时渲染进此槽，与 hame-page-scroll 并列（flex 行）；
              HeaderContext 导航栏不受影响，仅内容区被分割 */}
          <div id="dbh-copilot-home-dock-portal" />
        </div>
      </div>
    </>
  );
};
